<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-09 14:17:34
 * @Description: 法律法规
 -->

<template>
  <div class="m-law-wrapper">
    <a
      href="http://www.pbc.gov.cn/goutongjiaoliu/113456/113469/3641972/index.html"
      target="_blank"
      rel="noopener noreferrer"
      class="link-item"
    >
      <span class="title">互联网金融从业机构反洗钱和反恐怖融资管理办法（试行）</span>
      <span class="date">2018-10-10</span>
    </a>
    <a
      href="http://xxgk.xm.gov.cn/jrbzfxxgk/zfxxgkml/tzgg/bmtz/201802/t20180207_1847746.htm"
      target="_blank"
      rel="noopener noreferrer"
      class="link-item"
    >
      <span class="title">
        厦门市网络借贷风险专项整治联合工作办公室关于开展网络借贷风险专项整治整改验收工作的通知
      </span>
      <span class="date">2018-02-07</span>
    </a>
    <a
      href="http://www.cbrc.gov.cn/govView_C8D68D4C980A4410B9F4E21BA593B4F2.html"
      target="_blank"
      rel="noopener noreferrer"
      class="link-item"
    >
      <span class="title">
        中国银监会办公厅关于印发网络借贷信息中介机构业务活动信息披露指引的通知
      </span>
      <span class="date">2017-08-23</span>
    </a>
    <a
      href="http://www.cbrc.gov.cn/govView_4201EF03472544038242EED1878597CB.html"
      target="_blank"
      rel="noopener noreferrer"
      class="link-item"
    >
      <span class="title">中国银监会办公厅关于印发网络借贷资金存管业务指引的通知</span>
      <span class="date">2017-08-23</span>
    </a>
    <a
      href="http://xxgk.xm.gov.cn/jrbzfxxgk/zfxxgkml/gfxwj/201702/t20170209_1531289.htm"
      target="_blank"
      rel="noopener noreferrer"
      class="link-item"
    >
      <span class="title">
        厦门市金融工作办公室关于印发厦门市网络借贷信息中介机构备案登记管理暂行办法的通知
      </span>
      <span class="date">2017-02-04</span>
    </a>
    <a
      href="http://xxgk.xm.gov.cn/jrbzfxxgk/zfxxgkml/gfxwj/201711/t20171103_1821210.htm"
      target="_blank"
      rel="noopener noreferrer"
      class="link-item"
    >
      <span class="title">
        厦门市金融工作办公室关于厦门市网络借贷信息中介机构备案登记管理暂行办法的补充通知
      </span>
      <span class="date">2017-11-03</span>
    </a>
    <a
      href="http://www.cbrc.gov.cn/govView_E7B94B41E8C340E4833472632308AEC5.html"
      target="_blank"
      rel="noopener noreferrer"
      class="link-item"
    >
      <span class="title">关于印发网络借贷信息中介机构备案登记管理指引的通知</span>
      <span class="date">2016-10-28</span>
    </a>
    <a
      href="http://www.cbrc.gov.cn/govView_37D312933F1A4CECBC18F9A96293F450.html"
      target="_blank"
      rel="noopener noreferrer"
      class="link-item"
    >
      <span class="title">网络借贷信息中介机构业务活动管理暂行办法（银监会令[2016]1号）</span>
      <span class="date">2016-08-24</span>
    </a>
    <a
      href="http://www.cbrc.gov.cn/chinese/home/docView/D81B52D3D20A49A99522C48FA8F1C752.html"
      target="_blank"
      rel="noopener noreferrer"
      class="link-item"
    >
      <span class="title">关于印发《P2P网络借贷风险专项整治工作实施方案》的通知</span>
      <span class="date">2016-04-13</span>
    </a>
    <a
      href="http://www.gov.cn/zhengce/content/2016-10/13/content_5118471.htm"
      target="_blank"
      rel="noopener noreferrer"
      class="link-item"
    >
      <span class="title">国务院办公厅关于印发互联网金融风险专项整治工作实施方案的通知</span>
      <span class="date">2016-04-12</span>
    </a>
    <a
      href="http://www.miit.gov.cn/n1146285/n1146352/n3054355/n3057254/n3057259/c3868973/content.html"
      target="_blank"
      rel="noopener noreferrer"
      class="link-item"
    >
      <span class="title">中华人民共和国电子签名法</span>
      <span class="date">2015-08-23</span>
    </a>
    <a
      href="http://www.court.gov.cn/zixun-xiangqing-15146.html"
      target="_blank"
      rel="noopener noreferrer"
      class="link-item"
    >
      <span class="title">最高人民法院关于审理民间借贷案件适用法律若干问题的规定</span>
      <span class="date">2015-08-06</span>
    </a>
    <a
      href="http://www.gov.cn/xinwen/2015-07/18/content_2899360.htm"
      target="_blank"
      rel="noopener noreferrer"
      class="link-item"
    >
      <span class="title">关于促进互联网金融健康发展的指导意见</span>
      <span class="date">2015-07-18</span>
    </a>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scope>
.m-law-wrapper {
  box-sizing: border-box;
  font-size: 0.24rem;
  .link-item {
    padding: 0 0.2rem;
    display: flex;
    border-bottom: 0.02rem solid #e6e6e6;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    .title {
      display: inline-block;
      width: 4rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
</style>
